import { useParams } from 'react-router';
import SmsChatView from '../../../components/SmsChatView';

interface Props {
  noteableName?: string;
}

const ContactSmsNotes = ({ noteableName }: Props) => {
  const { id }: any = useParams();
  return <SmsChatView recordId={id} noteableType="Contact" noteableName={noteableName} />;
};

export default ContactSmsNotes;
